import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UserSmallCard from '../components';

function mapStateToProps(state) {
  return {
    actualUser: state.session.user,
  };
}

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserSmallCard));



// WEBPACK FOOTER //
// ./src/components/Cards/UserSmallCard/container/index.js